import { render, staticRenderFns } from "./CameraInfo.vue?vue&type=template&id=1bc4a906&scoped=true"
import script from "./CameraInfo.vue?vue&type=script&lang=js"
export * from "./CameraInfo.vue?vue&type=script&lang=js"
import style0 from "./CameraInfo.vue?vue&type=style&index=0&id=1bc4a906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc4a906",
  null
  
)

export default component.exports